/**
 * Formats a patient name for display purposes
 */
export default function formatPN(name) {
  if (!name) {
    return;
  }

  let nameToUse = name.Alphabetic ?? name;
  if (typeof nameToUse === 'object') {
    nameToUse = '';
  }

  // Convert the first ^ to a ', '. String.replace() only affects
  // the first appearance of the character.
  let commaBetweenFirstAndLast = nameToUse.replace('^', ', ');

  // Replace any remaining '^' characters with spaces
  commaBetweenFirstAndLast = commaBetweenFirstAndLast.replace(/\^/g, ' ');

  // Remove occurrences of 'null' from the string
  let cleaned = commaBetweenFirstAndLast.replace(/\bnull\b/g, '');

  // Trim any extraneous whitespace
  return cleaned.trim();
}
